import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-spinner-download',
    templateUrl: './dialog-spinner-download.component.html',
    styleUrls: ['./dialog-spinner-download.component.scss'],
    standalone: false
})
export class DialogSpinnerDownloadComponent implements OnInit {
	message;

	constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
		this.message = data.message || null;
	}

	ngOnInit() {}
}
